import styled from "styled-components";

export const Container = styled.div `

    position: relative;
    overflow: hidden;
    
    &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 20px;
        background-image: linear-gradient(to top, #202020, #20202000);
    }

`

export const Content = styled.div `

    display: flex;
    justify-content: center;
    position: relative;
    width: 100%;
    object-fit: cover;
    border-radius: 20px;
    background: #202020;

    .background-image-main {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        filter: blur(15px);
        background-position: center;
        background-size: 100%;
        background-repeat: no-repeat;
        opacity: .4;
    }

    @media (max-width: 1200px) {

        .background-image-main {
            background-size: 120%;
        }
        
    }

    @media (max-width: 1000px) {

        .background-image-main {
            background-size: 150%;
        }
        
    }

    @media (max-width: 800px) {

        height: 75vh;

        .background-image-main {
            background-size: 200%;
            opacity: .6;
        }
        
    }

    @media (max-width: 600px) {

        .background-image-main {
            background-size: 250%;
        }
        
    }

    @media (max-width: 500px) {

        .background-image-main {
            background-size: 270%;
        }
        
    }

    @media (max-width: 400px) {

        .background-image-main {
            background-size: 300%;
        }
        
    }
`

export const ContainerImage = styled.div `
    position: relative;
    margin: 70px auto 30px auto;
    width: 98%;
    background: #202020aa;
    border-radius: 20px;

    .container-age-rating {
        position: absolute;
        top: 50px;
        right: 0;
        z-index: 2;
    }

    .age-rating {
        position: relative;
        background-image: linear-gradient(to right, #ffffff90, #ffffff80, #ffffff00);
        padding: 8px 40px 8px 10px;
        margin-left: 20px;
        border-radius: 3px;
    }

    .age-rating::before {
        content: '';
        position: absolute;
        left: -7px;
        top: 0;
        background: #f00;
        height: 100%;
        width: 4px;
        border-radius: 50px;
    }

    .age-rating .span-classificacao-movie-principal {
        border-radius: 2px;
        font-size: 14px;
        font-weight: bold;
        padding: 5px 7px;
    }

    .span-classificacao-indicativa-0 {
        background: #009D4B;
    }

    .span-classificacao-indicativa-10 {
        background: #00A2E5;
    }

    .span-classificacao-indicativa-12 {
        background: #F2BF09;
        color: #000;
    }

    .span-classificacao-indicativa-14 {
        background: #EA7C1E;
    }

    .span-classificacao-indicativa-16 {
        background: #E21C21;
    }

    .span-classificacao-indicativa-18 {
        background: #000;
    }

    @media (max-width: 600px) {

        margin: 60px auto 30px auto;
        width: 95%;

        .age-rating {
            position: relative;
            background-image: linear-gradient(to right, #ffffff90, #ffffff80, #ffffff00);
            padding: 6px 25px 8px 4px;
            margin-left: 20px;
            border-radius: 3px;
        }

        .age-rating::before {
            width: 3px;
        }

        .age-rating .span-classificacao-movie-principal {
            border-radius: 2px;
            font-size: 12px;
            font-weight: bold;
            padding: 5px 6px;
        }

    }

`

export const Image = styled.img `
    position: relative;
    width: 100%;
    aspect-ratio: 16/9;
    max-height: 80dvh;
    border-radius: 20px;
    object-fit: cover;
    border: 3px solid #fff;
    opacity: .3;
    
    @media (max-width: 800px) {
        min-height: 100%;
        max-height: 100%;
        opacity: .5;
    }
`

export const Details = styled.div `
    display: flex;
    align-items: center;
    position: absolute;
    left: 0;
    top: 20px;
    width: 100%;
    height: 100%;
    z-index: 2;

    .div-details {
        width: 80%;
        display: flex;
        flex-direction: column;
        padding: 0 2.5%;
        margin-bottom: 100px;
        z-index: 2;
    }

    .title, .subtitle {
        font-display: block;
        text-transform: uppercase;
        font-family: 'Anton', Arial, sans-serif;
        font-weight: 100;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        max-width: 90%;
        -webkit-box-orient: vertical;
    }

    .title {
        margin-top: -10px;
        font-size: 3.5rem;
    }
    
    .subtitle {
        font-size: 2rem;
        margin: -20px 0 10px 0;
    }

    .div-details header {
        font-weight: 600;
    }

    .div-details header span {
        margin-right: 15px;
        text-transform: uppercase;
        color: #ddd;
        font-weight: 800;
        font-size: .9rem;
        white-space: nowrap;
    }

    .div-details header span:last-child {
        margin-right: 0;
    }

    .div-details header span:nth-child(1) {
        letter-spacing: 2px;
    }

    .overview {
        max-width: 450px;
        letter-spacing: 0;
        font-weight: 600;
        font-size: .9rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
    }

    .section-bt-watch-movie {
        margin: 25px 0 10px 0;
    }

    .watch-button {
        background: #ffffff;
        color: #000000;
    }

    .details-button {
        background: #6d6d6eb3;
        color: #ffffff;
    }

    .bt-watch-movie {
        padding: 13px 23px;
        font-size: .9rem;
        text-transform: capitalize;
        text-decoration: none;
        border-radius: 50px;
        margin-right: 10px;
        font-weight: 700;
        cursor: pointer;
        transition: all .3s ease;
    }

    .bt-details-movie {
        border: 2px solid #fff;
        background: #20202030;
        color: #fff;
    }

    .bt-details-movie:hover {
        background: #ffffff10 !important;
    }

    .bt-watch-movie:hover  {
        background: #aaa;
    }

    .available-on-app {
        width: max-content;
        border-radius: 50px;
        padding: 7px 15px;
        background: #f00;
        font-weight: 600;
        margin: 5px 0;
    }

    @media (max-width: 1200px) {

        .div-details header span {
            font-size: .85rem;
        }

        .title {
            margin: -15px 0 -20px 0;
            font-size: 4rem;
        }
        
        .subtitle {
            font-size: 1.7rem;
            margin-top: 0;
        }

        .overview {
            font-size: .85rem;
            -webkit-line-clamp: 3;
        }

    }

    @media (max-width: 1000px) {

        .title {
            margin-top: -10px;
            font-size: 3.7rem;
        }
        
        .subtitle {
            font-size: 1.5rem;
            margin-top: 5px;
        }

        .div-details header span {
            font-size: .85rem;
        }

        .overview {
            font-size: .85rem;
            -webkit-line-clamp: 3;
        }

    }

    @media (max-width: 800px) {

        top: unset;
        bottom: 70px;
        height: 70dvh;
        display: flex;
        align-items: end;
        overflow: hidden;

        .title, .subtitle {
            text-align: center;
            -webkit-line-clamp: 2;
            font-size: 2rem;
            line-height: 35px;
            margin: 0;
        }

        .div-details {
            align-items: center;
            width: 100%;
            margin-bottom: 0;
        }

        .overview {
            display: none;
        }

    }
    
    @media (max-width: 600px) {

        .title {
            font-size: 10dvw;
            line-height: 10dvw;
        }
        
        .subtitle {
            font-size: 6dvw;
            margin-top: 5px;
        }

        .section-bt-watch-movie {
            display: flex;
            justify-content: center;
            width: 100%;
            gap: 5px;
            padding: 0 10px;
            margin: 10px 0 0 0;
        }

        
        .bt-watch-movie {
            display: flex;
            justify-content: center;
            width: 45%;
            margin-right: 0;
            border-radius: 5px;
        }
        
        .bt-watch-movie i {
            margin-right: 5px;
        }

        
    }
    
    @media (max-width: 300px) {
        
        .subtitle {
            margin-top: 10px;
        }

    }

`